{
  "activity": {
    "appTrackingEnabled": "App- und Website-Erfassung erlauben",
    "appTrackingHint": "Name der aktiven App bzw. Domain im Browser und Fenstertitel.",
    "appsDisabled": "Die App-Erfassung ist in diesem Workspace nicht eingeschaltet.",
    "appsDisabledAdmin": "Die App-Erfassung ist nicht eingeschaltet (Einstellungen › Aktivität).",
    "autoDescription": "leer = Apps/Websites als Beschreibung",
    "backgroundHint": "Hinweis: Browser erfassen den Standort nur, solange die App geöffnet ist. Für lückenloses Tracking im Hintergrund ist später eine native App nötig.",
    "blur": "Screenshots unscharf speichern",
    "blurHint": "Inhalte sind nicht lesbar, nur die Aufteilung der Fenster ist erkennbar.",
    "blurred": "unscharf",
    "consentApps": "App- und Website-Erfassung erlauben",
    "consentOff": "Keine Zustimmung",
    "consentOn": "Zugestimmt",
    "consentScreenshots": "Screenshots erlauben",
    "consentScreenshotsBlurred": "Unscharfe Screenshots erlauben",
    "consentSwitch": "Ich stimme der Standorterfassung zu (Widerruf löscht meine Standorte)",
    "consentText": "Wenn du zustimmst, sendet die App bei laufendem Timer etwa alle {{interval}} Minuten deinen Standort. Er ist für Admins und deine Team-Manager sichtbar und wird nach {{days}} Tagen gelöscht.",
    "consentTitle": "Standorterfassung",
    "convertHint": "Aufeinanderfolgende Abschnitte (Lücke bis 5 Minuten) werden zu einem Eintrag zusammengefasst.",
    "convertSubmit": "Einträge anlegen",
    "convertTitle": "In Zeiteinträge umwandeln",
    "convert_one": "{{count}} Abschnitt übernehmen",
    "convert_other": "{{count}} Abschnitte übernehmen",
    "converted": "übernommen",
    "convertedCount_one": "{{count}} Eintrag angelegt",
    "convertedCount_other": "{{count}} Einträge angelegt",
    "days": "Tage",
    "deleteScreenshot": "Screenshot löschen?",
    "desktopConsentText": "Der Workspace hat die Erfassung durch den Desktop-Client eingeschaltet. Erfasst wird nur bei laufendem Timer; Daten werden nach {{days}} Tagen gelöscht, beim Widerruf sofort.",
    "desktopConsentTitle": "Zustimmung: Desktop-Client",
    "desktopDisableWarning": "Beim Abschalten werden alle gespeicherten Screenshots bzw. App-Daten des Workspaces gelöscht.",
    "desktopHint": "Der Desktop-Client erfasst nur während eines laufenden Timers und nur bei Personen, die zugestimmt haben. Vor dem Einschalten ggf. Betriebsrat und Datenschutz einbeziehen.",
    "desktopRetention": "Aufbewahrung",
    "desktopTitle": "Desktop-Client: Screenshots und App-Erfassung",
    "disableWarning": "Beim Speichern werden alle bisher erfassten Standorte gelöscht.",
    "disabled": "Die Standorterfassung ist in diesem Workspace ausgeschaltet.",
    "disabledAdmin": "Die Standorterfassung ist ausgeschaltet. Du kannst sie unter Einstellungen › Standorte einschalten.",
    "empty": "Keine Standorte an diesem Tag.",
    "entriesCount_one": "zu {{count}} Eintrag",
    "entriesCount_other": "zu {{count}} Einträgen",
    "gpsEnabled": "Standorterfassung erlauben",
    "gpsEnabledHint": "Jede Person entscheidet im Profil selbst, ob sie zustimmt.",
    "interval": "Intervall",
    "noAccess": "Keine Berechtigung für die Standorte dieser Person.",
    "noScreenshots": "Keine Screenshots an diesem Tag.",
    "noUsage": "Keine App-Nutzung an diesem Tag.",
    "person": "Person",
    "points_one": "{{count}} Standortpunkt",
    "points_other": "{{count}} Standortpunkte",
    "privacyNote": "Standorte werden nur bei laufendem Timer und mit Zustimmung erfasst und nach {{days}} Tagen automatisch gelöscht.",
    "retention": "Aufbewahrung",
    "screenshotAt": "Screenshot um {{time}}",
    "screenshotPrivacy": "Screenshots werden nach {{days}} Tagen automatisch gelöscht.",
    "screenshotsDisabled": "Screenshots sind in diesem Workspace nicht eingeschaltet.",
    "screenshotsDisabledAdmin": "Screenshots sind nicht eingeschaltet (Einstellungen › Aktivität).",
    "screenshotsEnabled": "Screenshots erlauben",
    "settingsHint": "Bei laufendem Timer sendet die App Standortpunkte – nur mit Zustimmung der jeweiligen Person. Abschalten löscht alle erfassten Standorte.",
    "settingsTitle": "Standorterfassung",
    "tabs": {
      "apps": "Apps & Websites",
      "locations": "Standorte",
      "screenshots": "Screenshots"
    },
    "timeline": "Zeitleiste",
    "topApps": "Meistgenutzt",
    "trackingActive": "Standort wird erfasst",
    "trackingError": "Standort nicht verfügbar: {{error}}",
    "untracked": "ohne Timer"
  },
  "admin": {
    "active": "Aktiv",
    "activeUsers": "aktiv (30 Tage)",
    "activeWorkspaces": "aktiv (30 Tage)",
    "addPlan": "Tarif anlegen",
    "billingMode": "Abrechnung",
    "code": "Code",
    "configured": "eingerichtet",
    "created": "Angelegt",
    "currency": "Währung",
    "days": "Tage",
    "deleteWorkspace": "Workspace löschen?",
    "deleteWorkspaceText": "„{{name}}“ wird für alle Mitglieder gelöscht. Das lässt sich nicht rückgängig machen.",
    "deleted": "Gelöscht",
    "description": "Beschreibung",
    "editPlan": "Tarif bearbeiten: {{name}}",
    "entriesToday": "Einträge heute",
    "extendTrial": "Testphase verlängern",
    "extendTrialFor": "Testphase verlängern: {{name}}",
    "failedEvents": "{{count}} fehlgeschlagene Ereignis-Zustellungen",
    "features": "Features",
    "forbidden": "Nur für Super-Admins.",
    "impersonate": "Als Benutzer anmelden",
    "impersonateHint": "Für Support-Fälle. Der Grund und alle Aktionen werden im Audit-Log des Workspaces protokolliert.",
    "impersonateTitle": "Als {{name}} anmelden",
    "imports": "Letzte Importe",
    "inactive": "inaktiv",
    "instance": "Installation",
    "internal": "intern",
    "jobs": "Hintergrund-Jobs",
    "lastActivity": "Letzte Aktivität",
    "lastLogin": "Letzte Anmeldung",
    "lock": "Sperren",
    "locked": "Gesperrt",
    "loginProviders": "Login-Anbieter",
    "mail": "E-Mail-Versand",
    "mailTest": "Test-E-Mail senden",
    "mailTestSent": "Test-E-Mail an deine Adresse gesendet.",
    "maintenance": "Wartungsmodus",
    "maintenanceHint": "Nur Super-Admins können die App nutzen; alle anderen sehen den Hinweis.",
    "maintenanceMessage": "Hinweistext",
    "maxMembers": "Max. Mitglieder",
    "members": "Mitglieder",
    "mrr": "MRR (netto)",
    "notConfigured": "nicht eingerichtet",
    "owner": "Owner",
    "perSeat": "pro Seat/Monat",
    "perSeatPerMonth": "pro Seat/Monat bei jährlicher Zahlung",
    "periodEnd": "Gültig bis",
    "plan": "Tarif",
    "planName": "Name",
    "priceMonthly": "Preis monatlich",
    "priceYearly": "Preis jährlich",
    "public": "Öffentlich buchbar",
    "reason": "Grund",
    "reasonPlaceholder": "z. B. Ticket #1234",
    "registration": "Registrierung",
    "registrationInvite": "Nur mit Einladung",
    "registrationOpen": "Offen",
    "reset2fa": "2FA zurücksetzen",
    "searchUsers": "Name oder E-Mail suchen …",
    "searchWorkspaces": "Workspace oder Owner suchen …",
    "sessionTimeout": "Sitzungsdauer bei Inaktivität",
    "setPlan": "Tarif setzen",
    "setPlanFor": "Tarif setzen: {{name}}",
    "setPlanHint": "Manuelle Zuweisung ohne Zahlung, z. B. für Rechnungskunden oder Kulanz.",
    "sortOrder": "Reihenfolge",
    "status": "Status",
    "storage": "Dateiablage",
    "subscriptions": "Abos",
    "tabs": {
      "audit": "Audit-Log",
      "overview": "Übersicht",
      "plans": "Tarife",
      "settings": "Einstellungen",
      "users": "Benutzer",
      "workspaces": "Workspaces"
    },
    "title": "Betreiber-Admin",
    "unlimitedHint": "leer = unbegrenzt",
    "unlock": "Entsperren",
    "users": "Benutzer",
    "webhookFailures": "Fehlerhafte Webhooks",
    "workspaces": "Workspaces"
  },
  "apiKeys": {
    "copy": "Kopieren",
    "created": "Neuer API-Schlüssel",
    "createdAt": "Erstellt",
    "generate": "Schlüssel erzeugen",
    "lastUsed": "Zuletzt verwendet",
    "name": "Bezeichnung",
    "onlyOnce": "Der Schlüssel wird nur einmal angezeigt. Bitte jetzt kopieren.",
    "prefix": "Schlüssel",
    "text": "Mit einem API-Schlüssel greifen Skripte und Integrationen in deinem Namen auf die REST-API zu (Header „Authorization: Bearer …“ oder „X-Api-Key“).",
    "title": "API-Schlüssel"
  },
  "approvals": {
    "actions": {
      "APPROVED": "Freigegeben",
      "REJECTED": "Abgelehnt",
      "SUBMITTED": "Eingereicht",
      "WITHDRAWN": "Zurückgezogen"
    },
    "allSubmitted": "Alle Zeiträume mit erfasster Zeit sind eingereicht.",
    "approve": "Genehmigen",
    "approveDirectly": "Direkt freigeben",
    "billable": "Abrechenbar",
    "expenses": "Ausgaben",
    "history": "Verlauf",
    "noArchive": "Noch keine entschiedenen Anträge.",
    "noPending": "Keine offenen Anträge.",
    "notSubmitted": "Nicht eingereicht",
    "period": "Zeitraum",
    "person": "Person",
    "reject": "Ablehnen",
    "rejectReason": "Grund der Ablehnung",
    "status": "Status",
    "statuses": {
      "APPROVED": "Freigegeben",
      "REJECTED": "Abgelehnt",
      "SUBMITTED": "Eingereicht",
      "WITHDRAWN": "Zurückgezogen"
    },
    "tabs": {
      "archive": "Archiv",
      "pending": "Offen",
      "unsubmitted": "Nicht eingereicht"
    },
    "total": "Gesamt",
    "withdraw": "Zurückziehen"
  },
  "attendance": {
    "absence": "Abwesenheit",
    "break": "Pause",
    "capacity": "Kapazität",
    "firstStart": "Erster Start",
    "lastEnd": "Letzter Stopp",
    "overtime": "Überstunden",
    "person": "Person",
    "work": "Arbeit"
  },
  "audit": {
    "action": "Aktion",
    "actor": "Person",
    "after": "Nachher",
    "before": "Vorher",
    "entity": "Objekt",
    "none": "Keine Ereignisse im Zeitraum.",
    "searchPlaceholder": "Aktion, Details oder ID …",
    "summary": "Details",
    "system": "System",
    "time": "Zeitpunkt",
    "viaImpersonation": "über {{name}} (Impersonation)",
    "workspace": "Workspace"
  },
  "banners": {
    "choosePlan": "Tarif wählen",
    "impersonating": "Du handelst als {{name}} (angemeldet als {{admin}}). Alle Aktionen werden protokolliert.",
    "maintenanceAdmin": "Wartungsmodus aktiv: {{message}} – nur Super-Admins können Änderungen vornehmen.",
    "pastDue": "Die letzte Zahlung ist fehlgeschlagen. Bitte aktualisiere die Zahlungsdaten, damit der Workspace nicht herabgestuft wird.",
    "stopImpersonation": "Impersonation beenden",
    "toBilling": "Zur Abrechnung",
    "trialEnds_one": "Die Testphase endet morgen.",
    "trialEnds_other": "Die Testphase endet in {{count}} Tagen.",
    "trialEnds_zero": "Die Testphase endet heute."
  },
  "billing": {
    "address": "Adresse",
    "cancelConfirm": "Kündigen",
    "cancelScheduled": "Gekündigt zum {{date}} – danach gilt {{plan}}.",
    "cancelText": "Der Tarif bleibt bis zum Ende des bezahlten Zeitraums aktiv, danach gilt Free.",
    "cancelTitle": "Abo kündigen?",
    "changeConfirm": "Weiter",
    "changeScheduled": "Wechsel zu {{plan}} zum {{date}} vorgemerkt.",
    "changeTextCheckout": "Du wirst zur sicheren Zahlung bei Mollie weitergeleitet (Kreditkarte, SEPA-Lastschrift, PayPal …).",
    "changeTextMandate": "Upgrades gelten sofort und werden anteilig abgebucht; Downgrades und Periodenwechsel gelten zum Ende des Zeitraums.",
    "changeTitle": "Zu {{plan}} wechseln?",
    "checkoutDone": "Danke! Die Zahlung wird verarbeitet – der Tarif wird in Kürze aktiviert.",
    "choose": "Auswählen",
    "company": "Firma / Name",
    "country": "Land",
    "current": "Aktueller Tarif",
    "currentPlan": "Aktueller Tarif",
    "details": "Rechnungsdaten",
    "downgrade": "Herabstufen",
    "free": "Kostenlos",
    "inTrial": "in Testphase",
    "invoiceEmail": "E-Mail für Rechnungen",
    "invoices": "Rechnungen",
    "mandateNo": "keins",
    "mandateYes": "hinterlegt",
    "maxMembers": "bis {{count}} Mitglieder",
    "moreFeatures": "… und {{count}} weitere",
    "noInvoices": "Noch keine Rechnungen.",
    "ownerOnly": "Nur der Workspace-Owner kann Tarif und Abrechnung verwalten.",
    "pastDue": "Zahlung fehlgeschlagen. Wir versuchen es erneut; ohne Zahlung wird der Workspace am {{date}} auf Free herabgestuft.",
    "paymentMethod": "Zahlungsmittel",
    "perSeatMonth": "pro Seat und Monat",
    "period": "Abrechnung",
    "periodEnd": "Nächste Abrechnung",
    "periods": {
      "MONTHLY": "Monatlich",
      "YEARLY": "Jährlich"
    },
    "plans": "Tarife",
    "providerMissing": "Der Zahlungsanbieter ist noch nicht konfiguriert. Bitte wende dich an den Betreiber.",
    "result": {
      "changed": "Tarif geändert.",
      "charged": "Upgrade auf {{plan}} – der anteilige Betrag wird abgebucht.",
      "redirect": "Weiterleitung zur Zahlung …",
      "scheduled": "Änderung zum Ende des Zeitraums vorgemerkt."
    },
    "reverseCharge": "Netto-Preise; Steuerschuldnerschaft des Leistungsempfängers (Reverse Charge).",
    "seats": "Seats",
    "selfHosted": "Diese Installation läuft ohne Abrechnung (Self-Hosted) – alle Funktionen sind freigeschaltet.",
    "status": {
      "ACTIVE": "Aktiv",
      "CANCELED": "Beendet",
      "PAST_DUE": "Zahlung offen",
      "TRIALING": "Testphase"
    },
    "taxNote": "Preise netto zzgl. {{rate}} % USt.",
    "tooManyMembers": "Zu viele Mitglieder",
    "totalMonthly": "{{amount}} / Monat für {{seats}} Seats",
    "totalYearly": "{{amount}} / Jahr für {{seats}} Seats",
    "trialEnds": "Testphase bis",
    "undo": "Rückgängig",
    "vatId": "USt-IdNr.",
    "yearlyDiscount": "Jährlich (günstiger)"
  },
  "branding": {
    "color": "Akzentfarbe",
    "colorHint": "Farbleiste in Kopfzeile und Login-Seite",
    "domain": "Eigene Domain",
    "domainHint": "Richte einen CNAME auf diese Installation ein; TLS-Zertifikat und Weiterleitung übernimmt der Reverse Proxy.",
    "loginLink": "Login-Link",
    "logo": "Logo",
    "logoHint": "PNG, JPEG oder WebP, höchstens 512 KB. Erscheint in der Kopfzeile und auf der Login-Seite.",
    "noLogo": "Kein Logo hochgeladen.",
    "slug": "Kürzel",
    "slugHint": "Für den Login-Link mit Branding und SSO.",
    "slugHintSubdomain": "Login über {{url}}",
    "uploadLogo": "Logo hochladen"
  },
  "calendar": {
    "connect": "Kalender verbinden",
    "day": "Tag",
    "hint": "Ziehen im Raster legt einen Eintrag an. Einträge lassen sich verschieben und am unteren Rand in der Dauer ändern; Klick öffnet die Details.",
    "newEntry": "Neuer Zeiteintrag",
    "openSource": "In Quelle öffnen",
    "startTimer": "Timer starten",
    "takeOver": "Als Eintrag übernehmen",
    "today": "Heute",
    "week": "Woche"
  },
  "calendarIntegration": {
    "add": "Abonnieren",
    "color": "Farbe",
    "externalText": "Termine aus Google, Outlook oder anderen Kalendern erscheinen in einer Spur neben deinen Einträgen. Nutze dazu die geheime ICS-Adresse des Kalenders.",
    "externalTitle": "Externe Kalender",
    "feedCreate": "Feed-Adresse erzeugen",
    "feedDisable": "Feed deaktivieren",
    "feedOnce": "Die Adresse wird nur jetzt angezeigt. Eine neue Adresse macht die alte ungültig.",
    "feedRenew": "Neue Adresse erzeugen",
    "feedText": "Abonniere deine erfassten Zeiten in Outlook, Google oder Apple Kalender. Die Adresse ist geheim – wer sie kennt, sieht deine Einträge.",
    "feedTitle": "Persönlicher Kalender-Feed (ICS)",
    "name": "Name",
    "title": "Kalender-Integration",
    "url": "ICS-Adresse"
  },
  "clients": {
    "address": "Adresse",
    "create": "Neuer Client",
    "currency": "Währung",
    "deleteText": "Client „{{name}}“ löschen?",
    "deleteTitle": "Client löschen",
    "edit": "Client bearbeiten",
    "email": "E-Mail",
    "empty": "Keine Clients.",
    "name": "Name",
    "note": "Notiz"
  },
  "comingSoon": {
    "description": "Die Funktion ist spezifiziert und wird in der angegebenen Release-Phase umgesetzt.",
    "features": "Features: {{features}}",
    "phase": "Phase {{phase}}",
    "title": "Dieser Bereich ist in Arbeit"
  },
  "common": {
    "actions": "Aktionen",
    "apply": "Übernehmen",
    "archive": "Archivieren",
    "archived": "Archiviert",
    "cancel": "Abbrechen",
    "confirm": "Bestätigen",
    "copied": "Kopiert",
    "copy": "Kopieren",
    "create": "Anlegen",
    "delete": "Löschen",
    "done": "Fertig",
    "edit": "Bearbeiten",
    "emailPlaceholder": "name@firma.de",
    "error": "Fehler",
    "me": "ich",
    "more": "Weitere Aktionen",
    "next": "Weiter",
    "no": "Nein",
    "previous": "Zurück",
    "remove": "Entfernen",
    "required": "Pflichtfeld",
    "restore": "Wiederherstellen",
    "save": "Speichern",
    "saved": "Gespeichert",
    "search": "Suchen",
    "teammates": "Teammitglieder",
    "undo": "Rückgängig",
    "yes": "Ja"
  },
  "customFields": {
    "activeInProject": "Aktiv",
    "add": "Feld hinzufügen",
    "adminOnly": "Nur Admins dürfen ändern",
    "adminOnlyHint": "Andere sehen den Wert, können ihn aber nicht setzen.",
    "allProjects": "Für alle Projekte aktiv",
    "allProjectsHint": "Ausgeschaltet: nur in Projekten, in denen das Feld aktiviert wird.",
    "defaultValue": "Default-Wert",
    "deleteText": "„{{name}}“ wird gelöscht. Bereits erfasste Werte bleiben in den Einträgen gespeichert, werden aber nicht mehr angezeigt.",
    "deleteTitle": "Feld löschen?",
    "edit": "Feld bearbeiten",
    "entityTimeEntry": "Zeiteinträge",
    "entityUser": "Profilfelder",
    "entryFields": "Weitere Felder",
    "entryHint": "Zusätzliche Angaben an Zeiteinträgen – im Tracker, Timesheet und in Reports (Spalte, Filter, Gruppierung, Export).",
    "filterField": "Feld",
    "filterValue": "Wert",
    "hidden": "Nur für Admins sichtbar",
    "hiddenHint": "Für alle anderen ausgeblendet (auch in Reports).",
    "name": "Name",
    "none": "Noch keine Felder.",
    "noneForProjects": "Es gibt noch keine Felder für Zeiteinträge (Einstellungen › Felder).",
    "options": "Auswahlwerte",
    "optionsHint": "Mit Enter bestätigen",
    "overridden": "Projekt-Einstellung",
    "profileFields": "Profilfelder",
    "projectDefault": "Default im Projekt",
    "properties": "Eigenschaften",
    "required": "Pflichtfeld",
    "reset": "Zurücksetzen",
    "saveProfileFields": "Profilfelder speichern",
    "selectedProjects": "Ausgewählte Projekte",
    "type": "Typ",
    "types": {
      "CHECKBOX": "Checkbox",
      "LINK": "Link",
      "MULTI_SELECT": "Mehrfachauswahl",
      "NUMBER": "Zahl",
      "SELECT": "Auswahl",
      "TEXT": "Text"
    },
    "userHint": "Benutzerdefinierte Angaben an Mitgliedern, z. B. Personalnummer oder Abteilung."
  },
  "dashboard": {
    "lastActive": "Zuletzt aktiv: {{when}}",
    "me": "Ich",
    "noActivity": "Noch keine Aktivität",
    "projects": "Projekte",
    "team": "Team",
    "teamActivity": "Team-Aktivität",
    "topActivities": "Top-Aktivitäten"
  },
  "days": {
    "FRIDAY": "Fr",
    "MONDAY": "Mo",
    "SATURDAY": "Sa",
    "SUNDAY": "So",
    "THURSDAY": "Do",
    "TUESDAY": "Di",
    "WEDNESDAY": "Mi"
  },
  "entryTypes": {
    "BREAK": "Pause",
    "HOLIDAY": "Feiertag",
    "REGULAR": "Arbeit",
    "TIME_OFF": "Abwesenheit"
  },
  "errors": {
    "breaks-disabled": "Pausen sind in diesem Workspace deaktiviert.",
    "client-in-use": "Der Client hat noch Projekte. Bitte archivieren.",
    "concurrent-modification": "Der Datensatz wurde zwischenzeitlich geändert. Bitte neu laden.",
    "domain-taken": "Die Domain ist bereits vergeben.",
    "end-before-start": "Das Ende liegt vor dem Start.",
    "entry-exceeds-max": "Der Eintrag überschreitet die maximale Dauer.",
    "feature-not-available": "Diese Funktion ist im aktuellen Tarif nicht enthalten oder deaktiviert.",
    "forbidden": "Keine Berechtigung für diese Aktion.",
    "future-entry": "Einträge in der Zukunft sind nicht erlaubt.",
    "integrity-violation": "Der Name ist bereits vergeben.",
    "invalid-slug": "Das Kürzel ist ungültig oder reserviert.",
    "maintenance": "Wartungsarbeiten – Änderungen sind gerade nicht möglich.",
    "no-running-timer": "Es läuft kein Timer.",
    "project-in-use": "Auf das Projekt wurde bereits Zeit erfasst. Bitte archivieren.",
    "required-fields-missing": "Bitte Pflichtfelder ausfüllen: {{fields}}",
    "seat-limit": "Das Mitglieder-Limit des Tarifs ist erreicht.",
    "slug-taken": "Das Kürzel ist bereits vergeben.",
    "sso-domain-taken": "Die Domain ist bereits einem anderen Workspace zugeordnet.",
    "sso-required": "Für diese E-Mail-Adresse ist Single Sign-on vorgeschrieben.",
    "tag-in-use": "Der Tag wird verwendet. Bitte archivieren.",
    "task-in-use": "Auf den Task wurde bereits Zeit erfasst. Bitte als erledigt markieren.",
    "too-many-members": "Der Tarif erlaubt nicht so viele aktive Mitglieder.",
    "two-factor-required": "Dieser Workspace verlangt die Zwei-Faktor-Anmeldung.",
    "workspace-locked": "Der Workspace ist gesperrt. Bitte wende dich an den Support."
  },
  "expenses": {
    "add": "Ausgabe erfassen",
    "addCategory": "Kategorie hinzufügen",
    "amount": "Betrag",
    "billing": "Abrechnung",
    "byAmount": "Per Betrag",
    "category": "Kategorie",
    "chooseFile": "Datei wählen",
    "count": "Anzahl",
    "date": "Datum",
    "edit": "Ausgabe bearbeiten",
    "editCategory": "Kategorie bearbeiten",
    "empty": "Keine Ausgaben im Zeitraum.",
    "noCategories": "Noch keine Kategorien – ein Admin legt sie unter Ausgaben › Kategorien an.",
    "note": "Notiz",
    "perUnit": "Abrechnung per Einheit",
    "perUnitHint": "Z. B. Kilometer × Kilometerpauschale – der Betrag wird aus der Menge berechnet.",
    "perUnitValue": "{{price}} pro {{unit}}",
    "person": "Person",
    "quantity": "Menge ({{unit}})",
    "receipt": "Beleg",
    "receiptsZip": "Belege (ZIP)",
    "removeReceipt": "Beleg entfernen",
    "tabs": {
      "categories": "Kategorien",
      "list": "Ausgaben"
    },
    "takePhoto": "Foto aufnehmen",
    "total": "Summe",
    "unitName": "Einheit",
    "unitPrice": "Preis pro Einheit"
  },
  "features": {
    "ACTIVITY": "Aktivität (GPS, Screenshots)",
    "APPROVALS": "Freigaben",
    "ATTENDANCE_REPORT": "Anwesenheits-Report",
    "AUDIT_LOG": "Audit-Log",
    "BRANDING": "Branding & eigene Domain",
    "BREAKS": "Pausen",
    "BUDGETS": "Budgets & Schätzungen",
    "BULK_EDIT": "Massenbearbeitung",
    "CALENDAR": "Kalender",
    "COST_RATES": "Kostensätze & Profit",
    "CUSTOM_FIELDS": "Benutzerdefinierte Felder",
    "EXPENSES": "Ausgaben",
    "GPS": "GPS-Standorte",
    "HISTORIC_RATES": "Historische Sätze",
    "IMPORT": "Import",
    "INVOICING": "Rechnungen",
    "KIOSK": "Kiosk",
    "LOCK_ENTRIES": "Einträge sperren",
    "PROJECT_TEMPLATES": "Projektvorlagen",
    "REQUIRED_FIELDS": "Pflichtfelder",
    "SCHEDULED_REPORTS": "Report-Abos",
    "SCHEDULING": "Planung",
    "SCREENSHOTS": "Screenshots & App-Erfassung",
    "SSO": "Single Sign-on & SCIM",
    "TEAM_MANAGERS": "Team-Manager",
    "TIMESHEET": "Timesheet",
    "TIME_FOR_OTHERS": "Zeit für andere erfassen",
    "TIME_OFF": "Abwesenheiten",
    "USER_FIELDS": "Profilfelder",
    "WEBHOOKS": "Webhooks"
  },
  "gates": {
    "maintenanceTitle": "Wartungsarbeiten",
    "reload": "Neu laden",
    "twoFactorText": "Dieser Workspace verlangt die Zwei-Faktor-Anmeldung. Richte sie hier ein, um weiterzuarbeiten – oder wechsle den Workspace.",
    "twoFactorTitle": "Zwei-Faktor-Anmeldung erforderlich"
  },
  "header": {
    "admin": "Betreiber-Admin",
    "createWorkspace": "Workspace anlegen",
    "help": "Hilfe & API",
    "integrations": "Integrationen",
    "logout": "Abmelden",
    "notifications": "Benachrichtigungen",
    "profile": "Profil",
    "workspaceSettings": "Workspace-Einstellungen",
    "workspaces": "Workspaces"
  },
  "import": {
    "apiKey": "Clockify-API-Schlüssel",
    "chooseFile": "CSV-Datei wählen",
    "clockifyHint": "Der Import läuft im Hintergrund und kann wiederholt werden – bereits übernommene Daten werden erkannt und nicht doppelt angelegt. Mitglieder werden als eingeladene Konten angelegt.",
    "clockifyText": "Übernimmt Mitglieder, Gruppen, Clients, Tags, Projekte (inkl. Zugriff, Sätze und Schätzungen), Tasks und Zeiteinträge über die Clockify-API.",
    "clockifyTitle": "Import aus Clockify",
    "connect": "Verbinden",
    "counts": {
      "clients": "Clients",
      "created": "angelegt",
      "entriesCreated": "Einträge neu",
      "entriesSkipped": "Einträge übersprungen",
      "entriesUpdated": "Einträge aktualisiert",
      "errors": "Fehler",
      "groups": "Gruppen",
      "projects": "Projekte",
      "skipped": "übersprungen",
      "tags": "Tags",
      "tasks": "Tasks",
      "updated": "aktualisiert",
      "users": "Personen"
    },
    "csvText": "Spalten werden automatisch erkannt (z. B. aus Clockify-, Toggl- oder Harvest-Exporten) und lassen sich anpassen. Fehlende Projekte, Clients, Tasks und Tags werden angelegt.",
    "csvTitle": "Zeiteinträge aus CSV",
    "entriesRange": "Zeiteinträge im Zeitraum",
    "exportButton": "Export herunterladen",
    "exportText": "Lädt alle Daten dieses Workspaces als ZIP-Archiv mit JSON-Dateien herunter (z. B. für Archivierung oder Datenauskunft).",
    "exportTitle": "Workspace exportieren",
    "fields": {
      "BILLABLE": "Abrechenbar",
      "CLIENT": "Client",
      "DESCRIPTION": "Beschreibung",
      "DURATION": "Dauer",
      "END_DATE": "Enddatum",
      "END_DATETIME": "Ende (Datum + Zeit)",
      "END_TIME": "Endzeit",
      "PROJECT": "Projekt",
      "START_DATE": "Startdatum",
      "START_DATETIME": "Start (Datum + Zeit)",
      "START_TIME": "Startzeit",
      "TAGS": "Tags",
      "TASK": "Task",
      "USER_EMAIL": "E-Mail der Person",
      "USER_NAME": "Name der Person"
    },
    "history": "Bisherige Importe",
    "importExpenses": "Ausgaben übernehmen (inkl. Kategorien)",
    "importGroups": "Gruppen übernehmen",
    "importInvoices": "Rechnungen übernehmen",
    "importRates": "Stundensätze übernehmen",
    "importSchedule": "Planung übernehmen (Assignments)",
    "importTimeOff": "Abwesenheiten übernehmen (Arten, Feiertage, Anträge)",
    "rowsFound": "{{count}} Zeilen gefunden",
    "run": "Importieren",
    "sourceWorkspace": "Clockify-Workspace",
    "start": "Import starten",
    "status": {
      "CANCELED": "Abgebrochen",
      "DONE": "Abgeschlossen",
      "FAILED": "Fehlgeschlagen",
      "QUEUED": "Wartend",
      "RUNNING": "Läuft"
    }
  },
  "invite": {
    "accept": "Einladung annehmen",
    "createAccount": "Konto erstellen und beitreten",
    "invalid": "Diese Einladung ist ungültig oder wurde bereits verwendet.",
    "loginFirst": "Mit bestehendem Konto anmelden",
    "text": "Du wurdest in den Workspace „{{workspace}}“ eingeladen.",
    "title": "Einladung"
  },
  "invoices": {
    "addItem": "Position hinzufügen",
    "addPayment": "Zahlung erfassen",
    "amount": "Betrag",
    "bankName": "Bank",
    "client": "Client",
    "clientAddress": "Anschrift",
    "clientEmail": "E-Mail des Clients",
    "companyAddress": "Anschrift",
    "companyEmail": "E-Mail",
    "companyName": "Firma",
    "create": "Rechnung anlegen",
    "defaultNote": "Standard-Hinweis",
    "description": "Beschreibung",
    "discount": "Rabatt",
    "dueDate": "Fällig am",
    "dueDays": "Zahlungsziel (Tage)",
    "empty": "Noch keine Rechnungen.",
    "filters": {
      "all": "Alle",
      "open": "Offen"
    },
    "footer": "Fußzeile",
    "grouping": "Gruppierung",
    "groupings": {
      "ENTRY": "Je Eintrag",
      "PROJECT": "Je Projekt",
      "TASK": "Je Task",
      "USER": "Je Person"
    },
    "import": "Übernehmen",
    "importHint": "Übernimmt nicht abgerechnete, abrechenbare Zeiten der Projekte dieses Clients und markiert sie als abgerechnet.",
    "importTime": "Zeiten übernehmen",
    "includeExpenses": "Abrechenbare Ausgaben übernehmen",
    "includeTime": "Zeiten übernehmen",
    "issueDate": "Rechnungsdatum",
    "items": "Positionen",
    "locale": "Sprache der Rechnung",
    "markSent": "Als versendet markieren",
    "message": "Nachricht",
    "messagePlaceholder": "Optional – sonst ein Standardtext",
    "noItems": "Noch keine Positionen.",
    "note": "Hinweis auf der Rechnung",
    "number": "Nummer",
    "outstanding": "Offen",
    "padding": "Stellen",
    "payment": "Zahlung",
    "prefix": "Präfix",
    "publicLink": "Öffentlicher Link",
    "quantity": "Menge",
    "recipient": "Empfänger",
    "remaining": "Restbetrag",
    "saveItems": "Positionen speichern",
    "send": "Versenden",
    "settings": "Einstellungen",
    "status": "Status",
    "statuses": {
      "DRAFT": "Entwurf",
      "OVERDUE": "Überfällig",
      "PAID": "Bezahlt",
      "PARTIALLY_PAID": "Teilweise bezahlt",
      "SENT": "Versendet",
      "VOID": "Storniert"
    },
    "subject": "Betreff",
    "subtotal": "Zwischensumme",
    "tax1Name": "Steuer",
    "tax1Rate": "Steuersatz",
    "tax2Name": "2. Steuer",
    "tax2Rate": "2. Steuersatz",
    "taxId": "USt-IdNr.",
    "timeItem": "{{count}} Zeiteinträge",
    "total": "Gesamtbetrag",
    "unitPrice": "Einzelpreis",
    "void": "Stornieren",
    "voidText": "Die Rechnung wird storniert; die Nummer bleibt erhalten und abgerechnete Zeiten werden wieder abrechenbar."
  },
  "kiosk": {
    "allMembers": "Alle Mitglieder",
    "allowedGroups": "Zugelassene Gruppen",
    "allowedPeople": "Zugelassene Personen",
    "back": "Zurück",
    "backspace": "Löschen",
    "breakEnd": "Pause beenden",
    "breakStart": "Pause starten",
    "breakToday": "Pause heute",
    "breakTotal": "Pause: {{duration}}",
    "breaksAllowed": "Pausen erlauben",
    "clockIn": "Einstempeln",
    "clockInInto": "Einstempeln in {{name}}",
    "clockOut": "Ausstempeln",
    "copyLink": "Link kopieren",
    "create": "Kiosk anlegen",
    "defaultDeviceName": "Tablet",
    "defaultProject": "Standard-Projekt",
    "deleteText": "Kiosk „{{name}}“ löschen? Gekoppelte Geräte funktionieren danach nicht mehr.",
    "deleteTitle": "Kiosk löschen",
    "deviceName": "Gerätename",
    "devices": "Geräte",
    "devicesHint": "Entkoppelte Geräte müssen über den Kiosk-Link neu gekoppelt werden.",
    "devicesOf": "Geräte von „{{name}}“",
    "done": {
      "BREAK_END": "Pause beendet – weiter geht's!",
      "BREAK_START": "Pause gestartet – gute Erholung!",
      "CLOCK_IN": "Eingestempelt – einen guten Arbeitstag!",
      "CLOCK_OUT": "Ausgestempelt – bis bald!",
      "SWITCH_PROJECT": "Projekt gewechselt"
    },
    "edit": "Kiosk bearbeiten",
    "empty": "Noch keine Kiosks.",
    "enterPin": "PIN eingeben",
    "fullscreen": "Vollbild",
    "generatePin": "PIN erzeugen",
    "generatedPin": "Neue PIN (nur jetzt sichtbar):",
    "invalidLink": "Der Kiosk-Link ist ungültig oder wurde erneuert.",
    "lastSeen": "Zuletzt aktiv: {{time}}",
    "link": "Kiosk-Link",
    "listHint": "Ein Kiosk ist eine Stempeluhr, z. B. ein Tablet am Eingang. Öffne den Kiosk-Link einmal auf dem Gerät, um es zu koppeln.",
    "name": "Name",
    "namePlaceholder": "z. B. Filiale West",
    "newPin": "Neue PIN (4–6 Ziffern)",
    "noDevices": "Noch keine Geräte gekoppelt.",
    "noPin": "Für dich ist noch keine PIN hinterlegt. Bitte im Profil festlegen oder beim Admin anfragen.",
    "open": "Öffnen",
    "pair": "Koppeln",
    "pairText": "Dieses Gerät wird als Stempeluhr für den Kiosk eingerichtet. Danach ist keine Anmeldung nötig.",
    "pairTitle": "Gerät koppeln",
    "people": "Personen",
    "person": "Person",
    "pinLength": "PIN-Länge",
    "pinLocked": "Zu viele Fehlversuche. Bitte in einigen Minuten erneut versuchen.",
    "pinNotSet": "Keine PIN",
    "pinSaved": "PIN gespeichert",
    "pinSet": "PIN hinterlegt",
    "pinText": "Mit dieser PIN stempelst du an den Kiosks von „{{workspace}}“ ein und aus.",
    "pinTitle": "Kiosk-PIN",
    "presence": {
      "BREAK": "In Pause",
      "IN": "Eingestempelt",
      "OUT": "Ausgestempelt"
    },
    "projectSwitchAllowed": "Projektwechsel erlauben",
    "regenerateLink": "Neuen Link erzeugen",
    "revoke": "Entkoppeln",
    "revoked": "Dieses Gerät wurde entkoppelt. Bitte erneut koppeln.",
    "searchPerson": "Name suchen",
    "selectedCount": "{{count}} ausgewählt",
    "since": "Seit {{time}} ({{duration}})",
    "sinceColumn": "Seit",
    "status": "Status",
    "switchProject": "Projekt wechseln",
    "tabs": {
      "attendance": "Wer ist da",
      "kiosks": "Kiosks"
    },
    "timeout": "Automatische Abmeldung nach",
    "today": "Heute",
    "unavailable": "Der Kiosk ist nicht erreichbar.",
    "week": "Diese Woche",
    "workToday": "Arbeit heute",
    "workingOn": "Aktuell: {{name}}",
    "wrongPin": "Falsche PIN."
  },
  "legal": {
    "imprint": "Impressum",
    "privacy": "Datenschutz",
    "terms": "AGB"
  },
  "login": {
    "accountDeleted": "Dein Konto wurde gelöscht.",
    "accountLocked": "Dein Konto ist gesperrt.",
    "backendUnavailable": "Server nicht erreichbar",
    "code": "Code",
    "continueWith": "Weiter mit {{provider}}",
    "email": "E-Mail",
    "forgotPassword": "Passwort vergessen?",
    "invalidCode": "Der Code ist ungültig.",
    "invalidCredentials": "E-Mail oder Passwort ist falsch.",
    "invalidEmail": "Bitte eine gültige E-Mail-Adresse eingeben.",
    "maintenance": "Wartungsarbeiten: {{message}}",
    "memberInactive": "Deine Mitgliedschaft in diesem Workspace ist deaktiviert.",
    "noAccount": "Noch kein Konto?",
    "oauthEmailError": "Der Anbieter hat keine bestätigte E-Mail-Adresse geliefert.",
    "oauthError": "Die Anmeldung über den externen Anbieter ist fehlgeschlagen.",
    "oauthTerms": "Wenn du dich über einen Anbieter registrierst, gelten die <terms>AGB</terms> und die <privacy>Datenschutzerklärung</privacy>.",
    "or": "oder",
    "password": "Passwort",
    "passwordRequired": "Bitte das Passwort eingeben.",
    "recoveryCode": "Wiederherstellungscode",
    "recoveryHint": "Gib einen deiner Wiederherstellungscodes ein. Jeder Code ist nur einmal gültig.",
    "register": "Registrieren",
    "registrationClosed": "Neue Konten können derzeit nur per Einladung angelegt werden.",
    "sso": "Mit Single Sign-on anmelden",
    "ssoDisabled": "Single Sign-on ist für diesen Workspace nicht aktiv.",
    "ssoEmailUnverified": "Deine E-Mail-Adresse ist beim Identitätsanbieter nicht bestätigt.",
    "ssoError": "Die Anmeldung über den Identitätsanbieter ist fehlgeschlagen.",
    "ssoExpired": "Die Anmeldung ist abgelaufen. Bitte erneut versuchen.",
    "ssoNotProvisioned": "Für dein Konto besteht keine Mitgliedschaft in diesem Workspace. Bitte wende dich an den Admin.",
    "ssoRequired": "Für diese E-Mail-Adresse ist die Anmeldung per Single Sign-on vorgeschrieben.",
    "ssoWith": "Weiter mit SSO ({{name}})",
    "submit": "Anmelden",
    "title": "Anmelden",
    "tooManyAttempts": "Zu viele Fehlversuche. Bitte in 15 Minuten erneut versuchen.",
    "twoFactorHint": "Gib den 6-stelligen Code aus deiner Authenticator-App ein.",
    "twoFactorTitle": "Bestätigung in zwei Schritten",
    "useApp": "Code aus der App verwenden",
    "usePassword": "Stattdessen mit Passwort anmelden",
    "useRecovery": "Wiederherstellungscode verwenden",
    "verify": "Bestätigen",
    "version": "Firetracker {{version}}"
  },
  "nav": {
    "groups": {
      "analyze": "Analysieren",
      "manage": "Verwalten",
      "track": "Erfassen"
    },
    "items": {
      "activity": "Aktivität",
      "approvals": "Freigaben",
      "billing": "Tarif & Abrechnung",
      "calendar": "Kalender",
      "clients": "Clients",
      "dashboard": "Dashboard",
      "expenses": "Ausgaben",
      "invoices": "Rechnungen",
      "kiosks": "Kiosks",
      "projects": "Projekte",
      "reports": "Reports",
      "schedule": "Planung",
      "settings": "Einstellungen",
      "tags": "Tags",
      "team": "Team",
      "timeOff": "Abwesenheiten",
      "timesheet": "Timesheet",
      "tracker": "Time Tracker"
    },
    "label": "Hauptnavigation",
    "toggle": "Navigation ein-/ausblenden"
  },
  "notFound": {
    "back": "Zur Startseite",
    "description": "Die angeforderte Seite existiert nicht.",
    "title": "Seite nicht gefunden"
  },
  "notifications": {
    "email": "E-Mail",
    "empty": "Keine Benachrichtigungen",
    "inApp": "In der App",
    "markAllRead": "Alle als gelesen markieren",
    "push": "Push",
    "pushActive": "Push ist auf diesem Gerät aktiv ({{count}} Gerät(e) insgesamt).",
    "pushDenied": "Benachrichtigungen wurden im Browser blockiert.",
    "pushDisable": "Deaktivieren",
    "pushEnable": "Push auf diesem Gerät aktivieren",
    "pushInactive": "Push-Benachrichtigungen sind auf diesem Gerät nicht aktiv.",
    "pushSent": "Test-Benachrichtigung gesendet",
    "pushTest": "Test senden",
    "pushUnsupported": "Dieser Browser unterstützt keine Push-Benachrichtigungen (auf iOS: App zum Home-Bildschirm hinzufügen).",
    "settingsText": "Lege fest, worüber und auf welchem Weg du informiert wirst.",
    "settingsTitle": "Benachrichtigungen",
    "types": {
      "APPROVAL_DECIDED": "Timesheet freigegeben/abgelehnt",
      "APPROVAL_REMINDER": "Erinnerung: Timesheet einreichen",
      "APPROVAL_SUBMITTED": "Timesheet eingereicht",
      "BILLING": "Abrechnung & Tarif",
      "BUDGET_ALERT": "Budget-Warnung",
      "EMAIL_VERIFICATION": "E-Mail-Bestätigung",
      "IMPORT_FINISHED": "Import abgeschlossen",
      "INVITATION": "Einladungen",
      "INVOICE_SENT": "Rechnung versendet",
      "LOW_HOURS_REMINDER": "Erinnerung: zu wenig Zeit erfasst",
      "PASSWORD_RESET": "Passwort zurücksetzen",
      "SCHEDULED_REPORT": "Geplanter Report",
      "SCHEDULE_PUBLISHED": "Planung veröffentlicht",
      "TIMER_AUTO_STOPPED": "Timer automatisch gestoppt",
      "TIMER_RUNNING_LONG": "Timer läuft lange",
      "TIME_OFF_DECIDED": "Abwesenheit entschieden",
      "TIME_OFF_REQUESTED": "Abwesenheit beantragt",
      "WEEKLY_SUMMARY": "Wochenübersicht"
    }
  },
  "offline": {
    "conflictTitle": "{{count}} Offline-Änderung(en) konnten nicht übernommen werden",
    "hint": "Keine Verbindung. Timer und Einträge werden gespeichert und später übertragen.",
    "offline": "Offline",
    "offlinePending": "Offline · {{count}} ausstehend",
    "pending": "{{count}} Änderung(en) werden übertragen",
    "syncing": "Offline erfasste Änderungen werden übertragen."
  },
  "passwordReset": {
    "backToLogin": "Zurück zur Anmeldung",
    "done": "Dein Passwort wurde geändert. Du kannst dich jetzt anmelden.",
    "hint": "Wir senden dir einen Link, mit dem du ein neues Passwort festlegen kannst.",
    "invalid": "Der Link ist ungültig oder abgelaufen.",
    "newTitle": "Neues Passwort festlegen",
    "send": "Link senden",
    "sent": "Falls ein Konto mit dieser Adresse existiert, ist eine E-Mail unterwegs.",
    "title": "Passwort zurücksetzen"
  },
  "picker": {
    "create": "Projekt anlegen",
    "createNamed": "Projekt „{{name}}“ anlegen",
    "createTag": "Tag „{{name}}“ anlegen",
    "empty": "Keine Projekte",
    "favorites": "Favoriten",
    "noProject": "Kein Projekt",
    "noTags": "Keine Tags",
    "project": "Projekt",
    "search": "Projekt, Task oder Client suchen",
    "searchTags": "Tags suchen",
    "showTasks": "Tasks anzeigen",
    "tags": "Tags",
    "withoutClient": "Ohne Client"
  },
  "privacy": {
    "delete": "Konto löschen",
    "deleteConfirm": "Endgültig löschen",
    "deleteText": "Dein Konto wird anonymisiert und du wirst abgemeldet. Workspaces, in denen du der einzige Benutzer bist, werden gelöscht. Hast du Workspaces mit weiteren Mitgliedern, übertrage zuerst die Inhaberschaft.",
    "deleteTitle": "Konto endgültig löschen?",
    "export": "Meine Daten exportieren",
    "exportHint": "Lade alle zu deinem Konto gespeicherten Daten als ZIP herunter (JSON-Dateien, DSGVO Art. 15/20).",
    "title": "Datenschutz"
  },
  "profile": {
    "changePassword": "Passwort ändern",
    "currentPassword": "Aktuelles Passwort",
    "dateFormat": "Datumsformat",
    "decimal": "Dezimal (1,50)",
    "durationFormat": "Dauerformat",
    "groupSimilar": "Ähnliche Einträge zusammenfassen",
    "language": "Sprache",
    "newPassword": "Neues Passwort",
    "passwordChanged": "Passwort geändert",
    "preferences": "Präferenzen",
    "theme": "Darstellung",
    "themeDark": "Dunkel",
    "themeLight": "Hell",
    "themeSystem": "Wie System",
    "timeFormat": "Zeitformat",
    "timesheetStart": "Standard-Startzeit im Timesheet",
    "timezone": "Zeitzone",
    "title": "Profil",
    "weekStart": "Woche beginnt am"
  },
  "projects": {
    "access": "Zugriff",
    "addMember": "Mitglied oder Gruppe hinzufügen …",
    "addTask": "Task hinzufügen",
    "alertPercent": "Benachrichtigen bei",
    "allClients": "Alle Clients",
    "assignees": "Zugewiesen",
    "billable": "Abrechenbar",
    "budget": "Budget",
    "budgetProgress": "Budget",
    "byMember": "Nach Person",
    "byTask": "Nach Task",
    "client": "Client",
    "color": "Farbe",
    "copy": "Kopie",
    "create": "Neues Projekt",
    "deleteText": "Projekt „{{name}}“ endgültig löschen? Projekte mit erfasster Zeit können nur archiviert werden.",
    "deleteTitle": "Projekt löschen",
    "done": "Erledigt",
    "duplicate": "Kopieren",
    "edit": "Projekt bearbeiten",
    "empty": "Keine Projekte gefunden.",
    "estimate": "Schätzung",
    "estimateHours": "Schätzung (h)",
    "estimateProgress": "Schätzung",
    "everyone": "Alle",
    "favorite": "Favorit",
    "fixedFee": "Fixpreis",
    "fixedFeeHint": "Fixpreis {{fee}}, bisherige Kosten {{cost}}",
    "fixedFeeResult": "Ergebnis Fixpreis (Fixpreis − Kosten)",
    "fromTasks": "Summe der Tasks",
    "fromTemplate": "Aus Vorlage anlegen",
    "includeExpenses": "Ausgaben ins Budget einrechnen",
    "includesExpenses": "inkl. Ausgaben: {{amount}}",
    "makePrivate": "Privat machen",
    "makePublic": "Öffentlich machen",
    "manager": "Projekt-Manager",
    "manual": "Manuell (Gesamt)",
    "markDone": "Als erledigt markieren",
    "member": "Mitglied / Gruppe",
    "membersPublicHint": "Öffentliches Projekt: Hier hinzugefügte Personen können Projekt-Manager werden oder eigene Sätze erhalten.",
    "monthly": "Monatlich",
    "name": "Name",
    "never": "Nie",
    "noClient": "Kein Client",
    "noTasks": "Keine Tasks",
    "none": "Keine",
    "notePlaceholder": "Notizen zum Projekt …",
    "onlyAssigneesTrack": "Nur zugewiesene Personen dürfen auf Tasks buchen",
    "private": "Privat",
    "privateHint": "Nur hinzugefügte Mitglieder und Gruppen sehen das Projekt.",
    "public": "Öffentlich",
    "publicHint": "Alle Mitglieder des Workspaces sehen das Projekt.",
    "reopen": "Wieder öffnen",
    "resetPeriod": "Zurücksetzen",
    "saveAsTemplate": "Als Vorlage speichern",
    "showArchived": "Archivierte anzeigen",
    "showDone": "Erledigte anzeigen",
    "showTemplates": "Vorlagen anzeigen",
    "tabs": {
      "access": "Zugriff",
      "budget": "Budget & Schätzung",
      "fields": "Felder",
      "note": "Notiz",
      "rates": "Sätze",
      "status": "Status",
      "tasks": "Tasks"
    },
    "taskName": "Task",
    "template": "Vorlage",
    "thisMonth": "dieser Monat",
    "withoutTask": "Ohne Task"
  },
  "pwa": {
    "reload": "Neu laden",
    "updateText": "Jetzt neu laden, um sie zu verwenden.",
    "updateTitle": "Neue Version verfügbar"
  },
  "range": {
    "custom": "Benutzerdefiniert …",
    "last2Weeks": "Letzte 2 Wochen",
    "lastMonth": "Letzter Monat",
    "lastWeek": "Letzte Woche",
    "lastYear": "Letztes Jahr",
    "next": "Nächster Zeitraum",
    "previous": "Vorheriger Zeitraum",
    "thisMonth": "Dieser Monat",
    "thisWeek": "Diese Woche",
    "thisYear": "Dieses Jahr",
    "today": "Heute",
    "yesterday": "Gestern"
  },
  "rates": {
    "allTime": "Alle Einträge",
    "billableRate": "Stundensatz",
    "costRate": "Kostensatz",
    "inherited": "geerbt",
    "projectRate": "Projektsatz",
    "projectRateHint": "Gilt für alle Einträge des Projekts, sofern kein spezifischerer Satz (Mitglied im Projekt, Task) gesetzt ist.",
    "validFrom": "Gültig ab …",
    "validFromHint": "Ab welchem Datum gilt der neue Satz? Leer = für alle Einträge.",
    "workspaceDefault": "Workspace-Satz",
    "workspaceRate": "Standard-Stundensatz",
    "workspaceRateHint": "Gilt für alle Einträge ohne spezifischeren Satz (Mitglied, Projekt, Task)."
  },
  "register": {
    "acceptTerms": "Ich stimme den <terms>AGB</terms> zu und habe die <privacy>Datenschutzerklärung</privacy> zur Kenntnis genommen.",
    "closed": "Die Registrierung ist geschlossen – neue Konten nur per Einladung.",
    "emailTaken": "Für diese E-Mail-Adresse gibt es bereits ein Konto.",
    "haveAccount": "Schon ein Konto?",
    "invitedTo": "Du wurdest in den Workspace „{{workspace}}“ eingeladen.",
    "name": "Name",
    "nameRequired": "Bitte den Namen eingeben.",
    "passwordHint": "Mindestens 8 Zeichen",
    "passwordTooShort": "Mindestens 8 Zeichen.",
    "submit": "Konto erstellen",
    "termsRequired": "Bitte stimme den AGB zu.",
    "title": "Konto erstellen"
  },
  "reports": {
    "amount": "Betrag",
    "amountDisplay": "Betragsanzeige",
    "amountModes": {
      "amount": "Umsatz",
      "cost": "Kosten",
      "hide": "Beträge ausblenden",
      "profit": "Profit"
    },
    "assignments": "Geplant vs. erfasst",
    "attendance": "Anwesenheit",
    "audit": "Audit-Log",
    "billable": "Abrechenbar",
    "copyLink": "Link kopieren",
    "detailed": "Detailed",
    "dim": {
      "BILLABILITY": "Abrechenbarkeit",
      "CLIENT": "Client",
      "CUSTOM_FIELD": "Feld",
      "DATE": "Datum",
      "DESCRIPTION": "Beschreibung",
      "MONTH": "Monat",
      "OVERTIME": "Überstunden",
      "PROJECT": "Projekt",
      "TAG": "Tag",
      "TASK": "Task",
      "TYPE": "Typ",
      "USER": "Person",
      "WEEK": "Woche"
    },
    "duration": "Dauer",
    "editShared": "Gespeicherten Report bearbeiten",
    "expand": "Auf-/Zuklappen",
    "expenses": "Ausgaben",
    "export": "Export",
    "filter": {
      "all": "Alle",
      "approval": "Freigabestatus",
      "approvalNone": "Nicht eingereicht",
      "noOvertime": "Ohne Überstunden",
      "notInvoiced": "Nicht abgerechnet",
      "overtimeOnly": "Nur Überstunden",
      "reset": "Zurücksetzen",
      "tagAll": "enthält alle",
      "tagAny": "enthält einen",
      "tagMode": "Tag-Logik",
      "tagNone": "enthält keinen",
      "team": "Team"
    },
    "groupBy": "Gruppieren nach",
    "noData": "Keine Daten im gewählten Zeitraum.",
    "noDescription": "(ohne Beschreibung)",
    "noSaved": "Noch keine gespeicherten Reports. Nutze „Exportieren → Speichern & teilen“ in einem Report.",
    "none": "(ohne)",
    "openPublic": "Öffentliche Ansicht öffnen",
    "print": "Drucken",
    "profit": "Profit",
    "projectUser": "Projekt / Person",
    "publicWarning": "Jeder mit dem Link kann diesen Report ohne Anmeldung sehen (inkl. Beträgen, falls sichtbar).",
    "rangeMode": "Zeitraum",
    "rangeModes": {
      "FIXED": "Fester Zeitraum (wie gewählt)",
      "LAST_30_DAYS": "Letzte 30 Tage",
      "LAST_MONTH": "Letzter Monat",
      "LAST_WEEK": "Letzte Woche",
      "LAST_YEAR": "Letztes Jahr",
      "THIS_MONTH": "Dieser Monat",
      "THIS_WEEK": "Diese Woche",
      "THIS_YEAR": "Dieses Jahr"
    },
    "recipients": "Empfänger",
    "recipientsHint": "E-Mail-Adressen, mit Enter bestätigen",
    "regularTime": "Reguläre Zeit",
    "reportName": "Name",
    "roundDown": "Abrunden",
    "roundNearest": "Kaufmännisch",
    "roundUp": "Aufrunden",
    "rounding": "Rundung",
    "roundingEnabled": "Zeiten runden",
    "roundingMinutes": "Auf Minuten",
    "roundingMode": "Richtung",
    "saveShare": "Speichern & teilen",
    "saved": "Gespeichert",
    "schedule": "Regelmäßig per E-Mail",
    "schedules": {
      "DAILY": "Täglich",
      "MONTHLY": "Monatlich (am 1.)",
      "NONE": "Nie",
      "WEEKLY": "Wöchentlich (montags)"
    },
    "segment": {
      "BILLABILITY": "Abrechenbarkeit",
      "CLIENT": "Client",
      "PROJECT": "Projekt",
      "USER": "Person"
    },
    "segmentation": "Diagramm aufteilen nach",
    "sharedNotFound": "Dieser Report existiert nicht oder ist nicht mehr geteilt.",
    "sharedVia": "Geteilter Report",
    "subscriptions": "Abos",
    "summary": "Summary",
    "title": "Titel",
    "total": "Gesamt",
    "type": "Art",
    "user": "Person",
    "userProject": "Person / Projekt",
    "visibility": "Sichtbarkeit",
    "visibilityPublic": "Öffentlich per Link",
    "visibilityWorkspace": "Workspace-Mitglieder",
    "week": "KW",
    "weekly": "Weekly",
    "weeklyTooLong": "Der Weekly-Report umfasst höchstens 62 Tage."
  },
  "schedule": {
    "addAssignment": "Assignment anlegen",
    "addMilestone": "Meilenstein",
    "copyNextWeek": "In die nächste Woche kopieren",
    "day": "Tag",
    "deleteSeries": "Diese und folgende der Serie löschen",
    "deviation": "Abweichung",
    "draft": "Entwurf",
    "editAssignment": "Assignment bearbeiten",
    "everyWeeks": "Alle … Wochen",
    "hint": "Ziehen verschiebt, rechter Rand verlängert, Rechtsklick für Kopieren/Teilen, Doppelklick auf einen Tag legt an.",
    "hoursPerDay": "Stunden pro Tag",
    "includeNonWorking": "Auch an arbeitsfreien Tagen",
    "legendFull": "ausgelastet",
    "legendOver": "überlastet",
    "legendUnder": "unter Kapazität",
    "loadTooltip": "Geplant {{planned}} von {{capacity}}",
    "milestoneName": "Meilenstein",
    "noPeople": "Keine Personen sichtbar.",
    "noProjects": "Keine geplanten Projekte im Zeitraum.",
    "note": "Notiz",
    "period": "Zeitraum",
    "person": "Person",
    "placeholder": "Platzhalter",
    "placeholderHint": "Z. B. „Designer:in“ – später einer Person zuweisen.",
    "placeholderName": "Name des Platzhalters",
    "planned": "Geplant",
    "plannedHours": "Geplant: {{hours}} h",
    "plannedToday": "Heute geplant",
    "plannedVsTracked": "Erfasst / geplant",
    "publish_one": "Veröffentlichen ({{count}})",
    "publish_other": "Veröffentlichen ({{count}})",
    "published_one": "{{count}} Assignment veröffentlicht.",
    "published_other": "{{count}} Assignments veröffentlicht.",
    "repeat": "Wiederholen",
    "repeatUntil": "Bis",
    "splitAt": "Am {{date}} teilen",
    "startTimer": "Timer starten",
    "tabs": {
      "projects": "Projekte",
      "team": "Team"
    },
    "tracked": "Erfasst",
    "weeks_one": "{{count}} Woche",
    "weeks_other": "{{count}} Wochen"
  },
  "security": {
    "activate": "Aktivieren",
    "copyCodes": "Codes kopieren",
    "disable": "Zwei-Faktor-Authentifizierung deaktivieren",
    "emailNotVerified": "Deine E-Mail-Adresse ist noch nicht bestätigt.",
    "enabled": "2FA aktiv",
    "qrAlt": "QR-Code für die Authenticator-App",
    "recoveryText": "Bewahre diese Codes sicher auf. Mit jedem Code kannst du dich einmal anmelden, falls du keinen Zugriff auf die App hast. Sie werden nur jetzt angezeigt.",
    "recoveryTitle": "Wiederherstellungscodes",
    "resend": "Bestätigung erneut senden",
    "scanHint": "Scanne den QR-Code mit deiner App und gib den angezeigten Code ein.",
    "setup": "Zwei-Faktor-Authentifizierung einrichten",
    "title": "Sicherheit",
    "twoFactorText": "Schütze dein Konto zusätzlich mit einer Authenticator-App (z. B. Google Authenticator, 1Password, Authy).",
    "verificationSent": "Bestätigungs-E-Mail wurde gesendet."
  },
  "securitySettings": {
    "acsUrl": "ACS-URL",
    "active": "Aktiv",
    "autoProvision": "Mitglieder automatisch anlegen",
    "autoProvisionHint": "Personen, die sich erfolgreich anmelden, werden Mitglied (zählt als Seat). Aus: nur eingeladene Personen.",
    "certificate": "Signatur-Zertifikat des Identitätsanbieters",
    "certificateHint": "PEM oder Base64 (X.509)",
    "clientId": "Client-ID",
    "clientSecret": "Client-Secret",
    "createToken": "Token erzeugen",
    "domains": "E-Mail-Domains",
    "domainsHint": "Für diese Domains bietet die Login-Seite SSO automatisch an.",
    "enabled": "SSO aktivieren",
    "enforce": "SSO erzwingen",
    "enforceHint": "Passwort-Anmeldung für Adressen der Domains sperren. Der Workspace-Owner kann sich weiterhin mit Passwort anmelden.",
    "idpEntityId": "Entity-ID des Identitätsanbieters",
    "inactive": "Inaktiv",
    "issuer": "Issuer-URL",
    "loginUrl": "Direkter Login-Link",
    "metadata": "SP-Metadaten herunterladen",
    "oidcHint": "Lege beim Identitätsanbieter (z. B. Entra ID, Google Workspace, Okta, Keycloak) eine Web-Anwendung an und trage diese Redirect-URI ein.",
    "ownNo2fa": "Du hast selbst noch keine 2FA eingerichtet – das ist im Profil nötig, bevor du weiterarbeiten kannst.",
    "ownerFallback": "Tipp: Teste die Anmeldung in einem privaten Fenster, bevor du SSO erzwingst.",
    "redirectUri": "Redirect-URI",
    "require2fa": "Zwei-Faktor-Anmeldung für alle Mitglieder verlangen",
    "require2faHint": "Mitglieder ohne 2FA können den Workspace erst nach der Einrichtung nutzen. Anmeldungen per SSO gelten als erfüllt.",
    "revokeToken": "Widerrufen",
    "rotate": "Neues Token erzeugen",
    "rotateText": "Das bisherige Token wird sofort ungültig. Trage das neue Token beim Identitätsanbieter ein.",
    "rotateTitle": "Neues SCIM-Token erzeugen?",
    "samlHint": "Lege beim Identitätsanbieter eine SAML-Anwendung an (oder importiere die Metadaten). Die Assertion muss signiert sein; die E-Mail-Adresse wird aus NameID oder dem Attribut „email“ gelesen.",
    "scimBaseUrl": "SCIM-Basis-URL",
    "scimHint": "Der Identitätsanbieter legt Mitglieder und Gruppen automatisch an und deaktiviert sie beim Austritt.",
    "scimTitle": "Benutzer-Provisionierung (SCIM 2.0)",
    "secretKept": "gespeichert – leer lassen, um es zu behalten",
    "spEntityId": "Entity-ID (Service Provider)",
    "ssoNotInPlan": "Single Sign-on (OIDC/SAML) und SCIM sind im aktuellen Tarif nicht enthalten.",
    "ssoTitle": "Single Sign-on",
    "ssoUrl": "SSO-URL (HTTP-Redirect)",
    "tokenOnce": "Das Token wird nur jetzt angezeigt. Kopiere es und trage es beim Identitätsanbieter als Bearer-Token ein.",
    "tokenTitle": "SCIM-Token",
    "twoFactorTitle": "Zwei-Faktor-Anmeldung"
  },
  "sessions": {
    "current": "Diese Sitzung",
    "device": "Gerät",
    "ip": "IP-Adresse",
    "lastActive": "Zuletzt aktiv",
    "revoke": "Abmelden",
    "revokeOthers": "Alle anderen abmelden",
    "since": "angemeldet seit {{date}}",
    "title": "Aktive Sitzungen"
  },
  "settings": {
    "approvalPeriod": "Freigabezeitraum",
    "approvalPeriods": {
      "MONTHLY": "Monatlich",
      "SEMI_MONTHLY": "Halbmonatlich",
      "WEEKLY": "Wöchentlich"
    },
    "approvals": "Freigaben",
    "approvalsIncludeExpenses": "Ausgaben in Freigaben einbeziehen (werden mit dem Zeitraum gesperrt)",
    "audience": {
      "ADMINS": "Nur Admins",
      "EVERYONE": "Alle",
      "MANAGERS": "Admins und Manager"
    },
    "autoStopHours": "Timer automatisch stoppen nach (h)",
    "breaksEnabled": "Pausen erfassen erlauben",
    "currency": "Währung",
    "currentPlan": "Aktueller Tarif",
    "defaultBillable": "Neue Einträge ohne Projekt sind abrechenbar",
    "deleteWorkspace": "Workspace löschen",
    "deleteWorkspaceConfirm": "Workspace „{{name}}“ wirklich löschen?",
    "deleteWorkspaceHint": "Der Workspace wird für alle Mitglieder unzugänglich.",
    "emptyNoLimit": "Leer = keine Begrenzung",
    "everyoneSeesAllReports": "Alle Mitglieder sehen alle Reports",
    "everyoneSeesTeamDashboard": "Alle Mitglieder sehen das Team-Dashboard",
    "forbidFuture": "Einträge in der Zukunft verbieten",
    "integrationsHint": "Integrationen (Webhooks, API-Schlüssel, Kalender) folgen in den nächsten Phasen. Die REST-API ist bereits unter /swagger-ui.html dokumentiert.",
    "lockBefore": "Gesperrt vor",
    "lockDays": "Tage",
    "lockEntries": "Einträge sperren",
    "lockFixed": "Vor einem festen Datum",
    "lockNone": "Keine Sperre",
    "lockRolling": "Älter als N Tage",
    "maxEntryHours": "Maximale Dauer eines Eintrags (h)",
    "notInPlan": "Nicht im aktuellen Tarif",
    "overtimeTagging": "Überstunden automatisch kennzeichnen",
    "overtimeTaggingHint": "Einträge, mit denen die Tageskapazität überschritten wird, erhalten das Kennzeichen „Überstunden“.",
    "projectManagersApprove": "Projekt-Manager genehmigen Zeiten ihrer Projekte",
    "requiredFields": "Pflichtfelder",
    "tabs": {
      "activity": "Aktivität",
      "branding": "Branding",
      "fields": "Felder",
      "general": "Allgemein",
      "import": "Import & Export",
      "integrations": "Integrationen",
      "modules": "Module & Tarif",
      "permissions": "Berechtigungen",
      "security": "Sicherheit",
      "tracking": "Zeiterfassung"
    },
    "task": "Task",
    "teamManagersApprove": "Team-Manager genehmigen die Zeiten ihres Teams",
    "whoCreatesClients": "Wer darf Clients anlegen?",
    "whoCreatesProjects": "Wer darf Projekte anlegen?",
    "whoCreatesTags": "Wer darf Tags anlegen?",
    "whoCreatesTasks": "Wer darf Tasks anlegen?",
    "whoSeesAmounts": "Wer sieht Sätze und Beträge?"
  },
  "subscriptions": {
    "active": "Aktiv",
    "edit": "Abo bearbeiten",
    "empty": "Noch keine Abos. Abonniere einen Report über „Export“ im Summary-, Detailed- oder Weekly-Report.",
    "format": "Format",
    "frequencies": {
      "DAILY": "Täglich",
      "MONTHLY": "Monatlich (am 1.)",
      "WEEKLY": "Wöchentlich (montags)"
    },
    "frequency": "Rhythmus",
    "hint": "Versand um 7 Uhr in deiner Zeitzone mit den Rechten des Erstellers.",
    "lastRun": "Zuletzt",
    "me": "ich",
    "name": "Name",
    "nextRun": "Nächster Versand",
    "paused": "pausiert",
    "periodHint": {
      "DAILY": "Enthält den Vortag.",
      "MONTHLY": "Enthält den Vormonat.",
      "WEEKLY": "Enthält die Vorwoche (Mo–So)."
    },
    "recipients": "Empfänger",
    "recipientsHint": "Du erhältst den Report immer; weitere Adressen mit Enter bestätigen.",
    "reportType": "Report: {{type}} mit den aktuellen Filtern",
    "sendNow": "Jetzt senden",
    "sent": "Report wurde versendet.",
    "subscribe": "Per E-Mail abonnieren …"
  },
  "tags": {
    "create": "Tag anlegen",
    "empty": "Keine Tags.",
    "name": "Neuer Tag"
  },
  "team": {
    "active": "Aktiv",
    "alreadyMembers": "Alle Adressen sind bereits Mitglied.",
    "cancelInvitation": "Einladung zurückziehen",
    "capacity": "Kapazität/Tag",
    "capacityPerDay": "Soll-Arbeitszeit pro Arbeitstag",
    "copyLink": "Link kopieren",
    "createGroup": "Gruppe anlegen",
    "deactivate": "Deaktivieren",
    "editGroup": "Gruppe bearbeiten",
    "emails": "E-Mail-Adressen",
    "emailsHint": "Mehrere Adressen durch Komma, Semikolon oder Zeilenumbruch trennen.",
    "group": "Gruppe",
    "groupName": "Gruppenname",
    "groups": "Gruppen",
    "inactive": "Inaktiv",
    "invitationLinks": "Einladungslinks (an die Personen weitergeben, E-Mail-Versand folgt mit Phase 2):",
    "invitationResent": "Einladung an {{email}} erneut gesendet.",
    "invite": "Mitglieder einladen",
    "invited": "Eingeladen",
    "managesGroups": "Verwaltet Gruppen",
    "managesMembers": "Verwaltet Mitglieder",
    "members": "Mitglieder",
    "name": "Name",
    "removeText": "„{{name}}“ wirklich entfernen? Erfasste Daten bleiben erhalten.",
    "resendInvitation": "Einladung erneut senden",
    "role": "Rolle",
    "roles": {
      "ADMIN": "Admin",
      "OWNER": "Owner",
      "TEAM_MANAGER": "Team-Manager",
      "USER": "Mitglied"
    },
    "sendInvitations": "Einladen",
    "transferOwnership": "Owner-Rolle übertragen",
    "transferTo": "An {{name}} übertragen",
    "workingDays": "Arbeitstage"
  },
  "timeOff": {
    "accrual": "Anspruch",
    "accrualTypes": {
      "ACCRUAL": "Monatlich angespart",
      "FIXED": "Fester Jahresanspruch",
      "UNLIMITED": "Ohne Kontingent"
    },
    "adjust": "Korrigieren",
    "adjustAmount": "Korrektur",
    "adjustHint": "Positiv = zusätzliches Guthaben, negativ = Abzug",
    "adjustments": "Korrekturen",
    "amount": "Umfang",
    "approval": "Genehmigung",
    "approvers": "Zusätzliche Genehmigende",
    "approversHint": "Admins und Team-Manager der Person können immer genehmigen.",
    "available": "verfügbar",
    "availableShort": "Verfügbar: {{value}}",
    "balance": "Saldo",
    "carryover": "Übertrag",
    "carryoverExpiry": "Übertrag verfällt nach (Monaten)",
    "carryoverHint": "Leer = kein Übertrag",
    "carryoverMax": "Max. Übertrag ins Folgejahr",
    "country": "Land",
    "createEntries": "Zeiteinträge für genehmigte Abwesenheiten erzeugen",
    "createHoliday": "Feiertag anlegen",
    "createHolidayEntries": "Zeiteinträge für Feiertage erzeugen",
    "createPolicy": "Abwesenheitsart anlegen",
    "daysShort": "Tage",
    "daysValue": "{{value}} Tage",
    "editPolicy": "Abwesenheitsart bearbeiten",
    "effectiveDate": "Gültig ab",
    "entitlement": "Anspruch",
    "entitlementHint": "Jahresanspruch bzw. bisher angesparter Anspruch",
    "firstHalf": "Erste Tageshälfte",
    "fullDay": "Ganzer Tag",
    "halfDay": "Umfang des Tages",
    "halfDaysAllowed": "Halbe Tage erlauben",
    "holidayName": "Name",
    "hours": "Stunden",
    "hoursValue": "{{value}} h",
    "import": "Importieren",
    "importHolidays": "Gesetzliche Feiertage importieren",
    "myRequests": "Meine Anträge",
    "nationwide": "Bundesweit",
    "negativeAllowed": "Negativen Saldo erlauben",
    "noHolidays": "Noch keine Feiertage.",
    "noPending": "Keine offenen Anträge.",
    "noPolicies": "Für dich ist keine Abwesenheitsart eingerichtet.",
    "noReport": "Keine Salden vorhanden.",
    "noRequests": "Noch keine Anträge.",
    "note": "Notiz",
    "onlyGroups": "Nur für Gruppen",
    "onlyGroupsHint": "Leer = gilt für alle",
    "pending": "Beantragt",
    "perYear": "Pro Jahr",
    "period": "Zeitraum",
    "person": "Person",
    "policy": "Art",
    "policyName": "Name",
    "record": "Eintragen",
    "recurring": "Jährlich",
    "region": "Bundesland/Kanton",
    "request": "Abwesenheit beantragen",
    "requiresApproval": "Genehmigungspflichtig",
    "restricted": "Nur Gruppen",
    "secondHalf": "Zweite Tageshälfte",
    "status": "Status",
    "statuses": {
      "APPROVED": "Genehmigt",
      "PENDING": "Beantragt",
      "REJECTED": "Abgelehnt",
      "WITHDRAWN": "Zurückgezogen"
    },
    "submitRequest": "Beantragen",
    "tabs": {
      "approvals": "Genehmigungen",
      "holidays": "Feiertage",
      "overview": "Übersicht",
      "policies": "Abwesenheitsarten",
      "report": "Salden",
      "timeline": "Team-Kalender"
    },
    "unit": "Einheit",
    "units": {
      "DAYS": "Tage",
      "HOURS": "Stunden"
    },
    "used": "Genommen",
    "usedUnlimited": "genommen (ohne Kontingent)",
    "year": "Jahr"
  },
  "timesheet": {
    "addBreak": "Pause hinzufügen",
    "addRow": "Projekt/Task hinzufügen",
    "approvalPeriod": "Freigabezeitraum {{period}}",
    "clearTemplate": "Vorlage entfernen",
    "copyLastWeek": "Zeilen der Vorwoche übernehmen",
    "copyLastWeekWithTimes": "Vorwoche inkl. Zeiten kopieren",
    "editFields": "Felder der Zeile",
    "empty": "Diese Woche ist noch leer. Füge eine Zeile hinzu oder übernimm die Vorwoche.",
    "fieldsHint": "Die Werte gelten für alle Einträge dieser Zeile in der Woche (außer gesperrten) und für neue Einträge.",
    "fieldsHintNew": "Die Werte werden für die Einträge übernommen, die du in dieser Zeile anlegst.",
    "fieldsMissing": "Pflichtfelder fehlen",
    "fieldsMixed": "Unterschiedliche Werte in der Woche: {{names}}. Ein neuer Wert gilt für alle Einträge.",
    "fields_one": "{{count}} Feld ausgefüllt",
    "fields_other": "{{count}} Felder ausgefüllt",
    "hint": "Dauer eingeben (z. B. 1:30, 1,5 oder 90m) und mit Enter oder Tab übernehmen. Leeren entfernt die Zeit des Tages.",
    "multipleEntries": "{{count}} Einträge – eine Änderung passt den letzten Eintrag an",
    "saveTemplate": "Als Vorlage speichern",
    "submit": "Zur Freigabe einreichen",
    "templateSaved": "Vorlage gespeichert"
  },
  "tracker": {
    "add": "Hinzufügen",
    "addDescription": "Beschreibung hinzufügen",
    "approved": "Freigegeben",
    "billable": "Abrechenbar",
    "break": "Pause",
    "breakMode": "Pause (Taste B)",
    "breakPlaceholder": "Pause",
    "bulkEdit": "Bearbeiten",
    "bulkEditTitle": "{{count}} Einträge bearbeiten",
    "changeProject": "Projekt ändern",
    "continue": "Fortsetzen",
    "date": "Datum",
    "deleted": "Eintrag gelöscht",
    "description": "Beschreibung",
    "discard": "Timer verwerfen",
    "duplicate": "Duplizieren",
    "duration": "Dauer",
    "editEntry": "Eintrag bearbeiten",
    "empty": "Noch keine Einträge. Starte den Timer oder erfasse Zeit manuell.",
    "end": "Ende",
    "endTime": "Endzeit",
    "groupCount": "{{count}} ähnliche Einträge",
    "invoiced": "Abgerechnet",
    "keep": "Unverändert",
    "lastWeek": "Letzte Woche",
    "loadMore": "Ältere Einträge laden",
    "locked": "Gesperrt",
    "manualMode": "Manuell",
    "nonBillable": "Nicht abrechenbar",
    "overtime": "Überstunden",
    "pending": "Wartet auf Freigabe",
    "project": "Projekt",
    "select": "Auswählen",
    "selectDay": "Alle Einträge des Tages auswählen",
    "selectedCount": "{{count}} Einträge ausgewählt",
    "splitHalf": "In der Mitte teilen",
    "start": "Start",
    "startTime": "Startzeit",
    "stop": "Stopp",
    "tags": "Tags",
    "tagsAdd": "Hinzufügen",
    "tagsRemove": "Entfernen",
    "tagsReplace": "Ersetzen",
    "thisWeek": "Diese Woche",
    "timerMode": "Timer",
    "today": "Heute",
    "total": "Summe",
    "weekTotal": "Wochensumme",
    "whatAreYouWorkingOn": "Woran arbeitest du?",
    "yesterday": "Gestern"
  },
  "verifyEmail": {
    "done": "Deine E-Mail-Adresse ist bestätigt.",
    "invalid": "Der Link ist ungültig oder abgelaufen.",
    "title": "E-Mail-Adresse bestätigen"
  },
  "webhooks": {
    "apiText": "Alle Funktionen sind über die REST-API erreichbar. Persönliche API-Schlüssel erzeugst du im Profil. Dokumentation:",
    "apiTitle": "REST-API",
    "attempts": "{{count}} Versuch(e)",
    "create": "Webhook anlegen",
    "deleteText": "Webhook „{{name}}“ löschen?",
    "deleteTitle": "Webhook löschen",
    "deliveries": "Zustellprotokoll",
    "deliveriesOf": "Zustellungen – {{name}}",
    "edit": "Webhook bearbeiten",
    "empty": "Noch keine Webhooks.",
    "enabled": "Aktiv",
    "events": "Ereignisse",
    "name": "Name",
    "noDeliveries": "Noch keine Zustellungen.",
    "notInPlan": "Webhooks sind im aktuellen Tarif nicht enthalten.",
    "ping": "Test senden",
    "redeliver": "Erneut zustellen",
    "rotate": "Neues Geheimnis",
    "secret": "Signatur-Geheimnis",
    "signatureHint": "Header „Firetracker-Signature: t=<Zeitstempel>,v1=<HMAC-SHA256 über Zeitstempel.Body>“",
    "text": "Bei Ereignissen (z. B. neuer Zeiteintrag) sendet Firetracker eine signierte HTTP-POST-Anfrage an deine URL. Fehlgeschlagene Zustellungen werden mit zunehmendem Abstand wiederholt.",
    "title": "Webhooks",
    "url": "Ziel-URL"
  },
  "workspace": {
    "create": "Workspace anlegen",
    "name": "Name des Workspaces",
    "noneText": "Du bist aktuell in keinem aktiven Workspace. Lege einen neuen an oder nimm eine Einladung an.",
    "noneTitle": "Kein Workspace"
  }
}
